import type React from 'react'

interface LeftDoubleChevronIconProps {
  size?: number | string
  color?: string
  className?: string
}

const LeftDoubleChevronIcon: React.FC<LeftDoubleChevronIconProps> = ({ size = 24, color = 'currentColor', className }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label={'Left Double Chevron Icon'}
      role="img"
    >
      <path
        d="M10.5981 4.95793C10.8421 4.71392 11.2378 4.71387 11.4818 4.95793C11.7258 5.20199 11.7258 5.59766 11.4818 5.84172L6.04809 11.2755C5.65086 11.6731 5.65064 12.3274 6.04809 12.7249L11.4818 18.1578C11.7259 18.4018 11.7258 18.7975 11.4818 19.0416C11.2378 19.2857 10.8421 19.2857 10.5981 19.0416L5.1643 13.6086C4.27857 12.7229 4.27856 11.2766 5.1643 10.3909L10.5981 4.95793Z"
        fill={color}
      />
      <path
        d="M17.9711 4.95793C18.2152 4.71392 18.6108 4.71387 18.8549 4.95793C19.0989 5.20199 19.0989 5.59766 18.8549 5.84172L13.4211 11.2755C13.0239 11.6731 13.0237 12.3274 13.4211 12.7249L18.8549 18.1578C19.0989 18.4018 19.0988 18.7975 18.8549 19.0416C18.6108 19.2857 18.2152 19.2857 17.9711 19.0416L12.5373 13.6086C11.6516 12.7229 11.6516 11.2766 12.5373 10.3909L17.9711 4.95793Z"
        fill={color}
      />
    </svg>
  )
}

export default LeftDoubleChevronIcon
